import { isNullOrUndefined } from 'app/helpers/objectHelpers';
import { TextField } from '@mui/material';
import { validInteger } from 'app/helpers/numberHelper';
import { isEmpty } from 'lodash';
import React from 'react';
import { Controller, useFormContext, useWatch } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { usePromiseTracker } from 'react-promise-tracker';
import { useSelector } from 'react-redux';
import { selectIsEditMod, selectIsEmiLmoDisabled } from 'store/redux-store/placement-mods/selectors';

export const LmoDaysWaived = () => {
  const { control, getValues, setValue, clearErrors, setError } = useFormContext();
  const { t } = useTranslation();
  const lmoDaysWaived: number | string | null | undefined = useWatch({ name: 'lmoDaysWaived' });
  const lmoNumberOfDays: number | string | null | undefined = useWatch({ name: 'lmoNumberOfDays' });
  const isModEdit = useSelector(selectIsEditMod);
  const { promiseInProgress: isSaveModApiCalling } = usePromiseTracker({ area: 'save-mod-api', delay: 0 });
  const isEmiLmoDisabled = useSelector(selectIsEmiLmoDisabled);
  const checkRequired = () => {
    if (
      (!isNullOrUndefined(getValues('lateMoveOutDate')) && !isEmpty(getValues('lateMoveOutDate'))) ||
      (!isNullOrUndefined(getValues('lmoNumberOfDays')) && getValues('lmoNumberOfDays') !== '') ||
      (!isNullOrUndefined(getValues('lmoCostPerDay')) && getValues('lmoCostPerDay') !== '') ||
      (!isNullOrUndefined(lmoDaysWaived) && lmoDaysWaived !== '')
    ) {
      return true;
    }
    return false;
  };

  const checkDaysValidation = currentLmoDaysWaived => {
    if (!isNullOrUndefined(lmoNumberOfDays) && !isNullOrUndefined(currentLmoDaysWaived)) {
      if (Number(currentLmoDaysWaived) > Number(lmoNumberOfDays)) {
        setError('lmoNumberOfDays', { message: t('placement.placementMods.daysWaivedError') });
        return;
      }
    } else {
      clearErrors('lmoNumberOfDays');
    }
    if (!checkRequired()) {
      clearErrors('lmoNumberOfDays');
    }
    return null;
  };

  return (
    <Controller
      control={control}
      name={'lmoDaysWaived'}
      rules={{
        validate: checkDaysValidation,
      }}
      render={({ field: { onChange, value, ...rest } }) => (
        <TextField
          value={lmoDaysWaived}
          variant="filled"
          fullWidth
          id="lmoDaysWaived"
          color="primary"
          label={t('placement.placementMods.daysWaived')}
          InputProps={{
            readOnly: !isModEdit || isEmiLmoDisabled,
            style: {
              pointerEvents: (isModEdit || isSaveModApiCalling) && !isEmiLmoDisabled ? 'auto' : 'none',
            },
          }}
          onChange={e => {
            if (validInteger(e.target.value, { numberLength: 4 })) {
              setValue('lmoDaysWaived', e.target.value, { shouldDirty: true });
              onChange(e.target.value);
            }
          }}
          InputLabelProps={{
            shrink: lmoDaysWaived ? true : null,
            sx: { marginTop: lmoDaysWaived ? '0px' : '-10px' },
          }}
          {...rest}
          disabled={isSaveModApiCalling}
          required={false}
        />
      )}
    />
  );
};
